module.exports = __webpack_public_path__ + "img/5882486ce81acb96424ffaae.79d1051c.png";